'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.set.difference.v2');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.set.difference.v2.js
// module id = 1494
// module chunks = 0